import { howToOrderParts, orderLink, linkLabel } from '../../utils/howToOrder';
import { safeUrl } from '../../utils/format';

// A catalogue supplier's "how to order": a bare link shows as its site name, and
// free text keeps any links and email addresses in it clickable.
export default function HowToOrder({ text, className = '' }) {
  const link = orderLink(text);
  if (link) {
    return (
      <a href={safeUrl(link)} target="_blank" rel="noopener noreferrer" title={link}
         onClick={e => e.stopPropagation()}
         className={`text-blue-700 hover:underline break-all ${className}`}>🔗 {linkLabel(link)}</a>
    );
  }
  const parts = howToOrderParts(text);
  if (!parts.length) return null;
  return (
    <span className={`whitespace-pre-wrap break-words ${className}`}>
      {parts.map((p, i) => p.type === 'text'
        ? <span key={i}>{p.value}</span>
        : <a key={i} href={safeUrl(p.href)} target={p.type === 'link' ? '_blank' : undefined} rel="noopener noreferrer"
             onClick={e => e.stopPropagation()} className="text-blue-700 hover:underline break-all">{p.value}</a>)}
    </span>
  );
}
